import { ResponseData } from "./types";

export async function withApiErrorHandling<T>(
  fn: () => Promise<ResponseData<T>>,
  errorMessage: string
): Promise<ResponseData<any>> {
  try {
    return await fn();
  } catch (error) {
    return {
      statusCode: 500,
      statusText: "Internal Server Error",
      message: errorMessage,
      data: null,
    };
  }
}
